
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 17.875a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm12 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM4.75 3.125a.75.75 0 01.725.557l.02.1.292 2.343H21.77c.498 0 .85.502.692.987l-2.475 7.633c-.364 1.123-1.387 1.88-2.539 1.88H6.203a.737.737 0 01-.726-.667l-.17-1.576-1.22-9.757H2.25a.75.75 0 01-.102-1.493l.102-.007h2.5z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    